import React, {useState} from 'react';
import {EditorState, convertFromRaw, convertToRaw} from 'draft-js';
import {draftToMarkdown, markdownToDraft} from 'markdown-draft-js';

import DraftEditor from './DraftEditor';
import {commentSchema} from './CommentEditor';
import {updateComment} from '../api/api';

const toEditorState = (text) => EditorState
  .createWithContent(convertFromRaw(markdownToDraft(text, {preserveNewlines: true})));

const toText = (editorState) => draftToMarkdown(
  convertToRaw(editorState.getCurrentContent()),
  {preserveNewlines: true},
);

const CommentEdit = ({
  id, currText, onFinish, isReply,
}) => {
  const [editorState, setEditorState] = useState(toEditorState(currText));
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const onEditorChange = (editor) => {
    setEditorState(editor);
    setError(null);
  };

  const handleSubmit = async () => {
    try {
      if (submitting) return;
      setSubmitting(true);
      const comment = {text: toText(editorState)};
      if (!isReply) await commentSchema.validate(comment);
      const status = await updateComment(id, comment);
      if (status === 'success') onFinish(comment.text);
    } catch (err) {
      setError(err);
    }

    setSubmitting(false);
  };

  return (
    <>
      <DraftEditor
        editorState={editorState}
        setEditorState={onEditorChange}
        onCancel={() => onFinish(currText)}
        onSubmit={handleSubmit}
        showToolbar
      />
      {error && (
        <div className="text-right text-red-600 text-sm pt-2 pb-4 px-4">
          {error.message}
        </div>
      )}
    </>
  );
};

export default CommentEdit;
